import { render, staticRenderFns } from "./SigninView.vue?vue&type=template&id=65c4582e&scoped=true&lang=pug&"
import script from "./SigninView.vue?vue&type=script&lang=js&"
export * from "./SigninView.vue?vue&type=script&lang=js&"
import style0 from "./SigninView.vue?vue&type=style&index=0&id=65c4582e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c4582e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VContainer,VImg})
